import { createFileRoute } from '@tanstack/react-router'
import { WargaTable } from '../../../../components/WargaTable'

export const Route = createFileRoute('/desa/$slug/dashboard/kependudukan')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <WargaTable desaId={desaId} />
  },
})
